import { useMelioIntl } from '@melio/ar-domain';
import { Bill, Vendor } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

import { LineItem, Section } from '../../../components';

export type PaymentDetailsSectionProps = {
  bill?: Bill;
  vendor?: Vendor;
  paddingX?: string;
};

export const PaymentDetailsSection = forwardRef<PaymentDetailsSectionProps>(({ bill, vendor, ...props }, ref) => {
  const { formatMessage } = useMelioIntl();

  return (
    <Section
      data-component={PaymentDetailsSection.displayName}
      title={formatMessage('ar.guestPayment.activities.paymentReview.sections.payTo.title.label')}
      {...props}
      ref={ref}
      direction="horizontal"
    >
      <LineItem label={formatMessage('ar.guestPayment.activities.paymentReview.subTitle.businessName.label')}>
        {vendor?.name}
      </LineItem>
      <LineItem label={formatMessage('ar.guestPayment.activities.paymentReview.subTitle.invoiceNumber.label')}>
        {bill?.invoice.number}
      </LineItem>
    </Section>
  );
});
PaymentDetailsSection.displayName = 'PaymentDetailsSection';
